var _defs, _g, _g2, _ellipse, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrainingImg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 768 480",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient-1",
    x1: 261.24,
    x2: 261.24,
    y2: 486.88,
    gradientTransform: "scale(1.4322 .69821)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F4FD",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.3199,7.4441)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 768,
    height: 480,
    display: "none",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "background",
    transform: "rotate(180,378.95,225.6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Oval",
    transform: "rotate(180,374.15,182.4)",
    d: "M 748.31,364.8 C 748.31,109.08 629.87,0 374.16,0 118.44,0 0.01,109.08 0.01,364.8 Z",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 694.31,
    cy: 169.2,
    r: 10.8,
    fill: "#e5eeff",
    fillOpacity: 0.49
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    transform: "rotate(150,32.108,194.4)",
    d: "m23.46 197.27c-2.3172-8.8588 8.4627-16.207 15.213-8.9594 6.75 7.2481-1.4104 17.416-10.075 14.496-1.8134-0.60401-2.6194 2.3154-0.80597 2.9194 11.687 3.926 21.761-10.268 12.996-19.53-8.7649-9.3621-23.373 0.10067-20.25 11.879 0.50373 1.9127 3.4254 1.1073 2.9216-0.80534z",
    fill: "#c4d2ed",
    fillOpacity: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 397.71,
    cy: 73.6,
    r: 14.4,
    fill: "#f3f6fd"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 156.11,
    cy: 323.92,
    r: 6,
    fill: "#d7dbe7"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(163,585.91,76.2)",
    d: "m580.37 78.532c-1.9825-6.3548 6.1953-11.464 10.284-5.7318 3.7172 5.2334-2.4781 11.339-7.8061 8.5977-2.1064-1.1214-3.965 2.1183-1.8586 3.2397 9.0451 4.735 18.958-5.981 12.391-14.33-6.6909-8.5977-19.701-0.87223-16.603 9.2207 0.74343 2.2429 4.3367 1.3706 3.5933-0.99684z",
    fill: "#c7d5ee",
    fillOpacity: 0.64
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-15,624.4,306.38)",
    d: "m614.71 310.46c-3.4694-11.121 10.842-20.061 17.997-10.031 6.5051 9.1584-4.3367 19.843-13.661 15.046-3.6862-1.9625-6.9387 3.707-3.2525 5.6695 15.829 8.2862 33.176-10.467 21.684-25.077-11.709-15.046-34.477-1.5264-29.056 16.136 1.301 3.925 7.5892 2.3986 6.2882-1.7445z",
    fill: "#e7eef9"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(30,652.31,76.8)",
    d: "m643.66 79.673c-2.3172-8.8588 8.4627-16.207 15.213-8.9594 6.75 7.2481-1.4104 17.415-10.075 14.496-1.8134-0.60401-2.6194 2.3154-0.80597 2.9194 11.687 3.926 21.761-10.268 12.996-19.53-8.7649-9.3621-23.373 0.10067-20.25 11.879 0.50374 1.9127 3.4254 1.1073 2.9216-0.80534z",
    fill: "#f4f7fe"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(179,84)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "screen_operator",
    transform: "translate(48,59.011)"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#5374a5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape",
    d: "m212.73 250.78c2.2664 0 4.1037 1.8373 4.1037 4.1037s-1.8373 4.1037-4.1037 4.1037h-111.14c-2.2664 0-4.1037-1.8373-4.1037-4.1037s1.8373-4.1037 4.1037-4.1037zm-42.36-53.804v48.332h-25.509v-48.332z",
    fill: "#5374a5",
    strokeWidth: 7.1131
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle",
    d: "m21.989 0h266.79c13.598 0 24.622 11.024 24.622 24.622v147.73c0 13.598-11.024 24.622-24.622 24.622h-264.16c-13.598 0-24.622-11.024-24.622-24.622v-150.37c0-12.144 9.8446-21.989 21.989-21.989z",
    fill: "#fff",
    strokeWidth: 7.8
  })), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m161 138.84-13.16-4.372v-1.2765c7.5091-5.522 12.397-14.426 12.397-24.457v-33.481c0-2.0787-1.6814-3.7644-3.7547-3.7644h-34.964c-11.999 0-21.762 9.787-21.762 21.817v15.428c0 10.031 4.8872 18.935 12.396 24.456v1.2765l-13.16 4.372c-14.951 4.9667-24.996 18.914-24.996 34.705v23.181c0 2.0787 1.6814 3.7644 3.7547 3.7644h104.49c2.0734 0 3.7547-1.6857 3.7547-3.7644v-23.181c0-15.79-10.045-29.738-24.996-34.704zm-39.483-59.822h31.21v18.998c-2.6745 1.1218-5.5686 1.7177-8.4883 1.7177-6.8531 0-13.193-3.1275-17.392-8.5802-0.71115-0.92303-1.8083-1.464-2.9719-1.464-1.1632 0-2.2607 0.54094-2.9719 1.4636-3.4198 4.4405-8.2585 7.3375-13.638 8.261v-6.1077c0-7.8785 6.3932-14.288 14.252-14.288zm-14.252 29.716v-1.7162c6.2697-0.79391 12.056-3.5592 16.609-7.9429 5.45 5.2472 12.664 8.1868 20.364 8.1868 2.8806 0 5.7451-0.42951 8.4883-1.2543v2.7266c0 12.566-10.197 22.789-22.731 22.789s-22.73-10.223-22.73-22.789zm32.794 28.586v5.4072c0 5.5626-4.514 10.089-10.063 10.089-5.5487 0-10.063-4.5256-10.063-10.089v-5.4068c3.1498 1.1176 6.5351 1.7324 10.062 1.7324 3.5276 0 6.9132-0.61472 10.063-1.7327zm28.236 55.641v-20.664c0-2.0787-1.6814-3.7644-3.7547-3.7644s-3.7547 1.6857-3.7547 3.7644v20.664h-61.578v-20.664c0-2.0787-1.6814-3.7644-3.7547-3.7644-2.0734 0-3.7547 1.6857-3.7547 3.7644v20.664h-10.193v-19.416c0-12.54 7.9766-23.614 19.848-27.558l11.07-3.6782v0.4186c0 9.7144 7.8827 17.617 17.572 17.617 9.6895 0 17.572-7.903 17.572-17.617v-0.4186l11.069 3.6778c11.872 3.9443 19.849 15.019 19.849 27.558v19.417z",
    display: "none",
    fill: "#5374a5",
    fillRule: "nonzero"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Nachkontrolle_img",
    transform: "translate(277.79,176)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "undraw_accept_request_vdsd"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 204.22,
    cy: 17.945,
    rx: 10.403,
    ry: 10.431,
    fill: "#fff",
    stroke: "#c7d5ee",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m223.12 2.9379-2.5152-2.5352c-0.24898-0.25524-0.58932-0.40019-0.94538-0.40269-0.35606-0.0024345-0.69836 0.13779-0.95083 0.38956l-15.789 15.699-6.6762-6.7471c-0.24792-0.25221-0.58562-0.3953-0.93878-0.39778s-0.69283 0.13586-0.94425 0.38456l-2.5414 2.522c-0.5238 0.52286-0.52968 1.3712-0.0132 1.9014l10.139 10.246c0.52145 0.52522 1.3675 0.53111 1.8962 0.01321l19.265-19.172c0.25454-0.24966 0.3991-0.59091 0.40161-0.94793 2e-3 -0.35702-0.13739-0.70025-0.38844-0.95343z",
    fill: "#5374a5"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    stroke: "#c7d5ee",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 204.22,
    cy: 55.496,
    rx: 10.403,
    ry: 10.431
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 204.22,
    cy: 93.047,
    rx: 10.403,
    ry: 10.431
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 204.22,
    cy: 136.6,
    rx: 10.403,
    ry: 10.431
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#5374a5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m223.12 40.837-2.5152-2.5352c-0.24898-0.25524-0.58932-0.40019-0.94538-0.40269-0.35606-0.0024-0.69836 0.13779-0.95083 0.38956l-15.789 15.699-6.6762-6.7471c-0.24792-0.25221-0.58562-0.3953-0.93878-0.39778-0.35316-0.0025-0.69283 0.13586-0.94425 0.38456l-2.5414 2.522c-0.5238 0.52286-0.52968 1.3712-0.0132 1.9014l10.139 10.246c0.52145 0.52521 1.3675 0.53111 1.8962 0.01321l19.265-19.172c0.25454-0.24966 0.3991-0.5909 0.40161-0.94793 2e-3 -0.35702-0.13739-0.70025-0.38844-0.95343z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m223.12 122.63-2.5152-2.5352c-0.24898-0.25524-0.58932-0.4002-0.94538-0.4027-0.35606-2e-3 -0.69836 0.1378-0.95083 0.38956l-15.789 15.699-6.6762-6.7471c-0.24792-0.25221-0.58562-0.3953-0.93878-0.39778-0.35316-2e-3 -0.69283 0.13586-0.94425 0.38456l-2.5414 2.522c-0.5238 0.52285-0.52968 1.3712-0.0132 1.9014l10.139 10.246c0.52145 0.52522 1.3675 0.53112 1.8962 0.0132l19.265-19.172c0.25453-0.24966 0.39909-0.5909 0.4016-0.94792 2e-3 -0.35702-0.13738-0.70024-0.38843-0.95342z"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 12.403,
    width: 160,
    height: 10,
    rx: 4.8
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,89.203)",
    fill: "#79a3ff"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 175.2,
    height: 9.6,
    rx: 4.8
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,50.803)",
    fill: "#5374a5"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 105.6,
    height: 9.6,
    rx: 4.8
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,127.6)",
    fill: "#5374a5"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 158.4,
    height: 9.6,
    rx: 4.8
  }))))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 553.53,
    cy: 313.54,
    rx: 53.855,
    ry: 64.536,
    fill: "#fff",
    strokeWidth: 1.5313
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m605.65 329.14-17.685-5.8752v-1.7154c10.091-7.4206 16.659-19.386 16.659-32.866v-44.992c0-2.7934-2.2595-5.0587-5.0457-5.0587h-46.986c-16.125 0-29.244 13.152-29.244 29.319v20.732c0 13.479 6.5675 25.445 16.658 32.865v1.7154l-17.685 5.8752c-20.091 6.6744-33.59 25.417-33.59 46.637v31.151c0 2.7934 2.2595 5.0587 5.0457 5.0587h140.42c2.7862 0 5.0457-2.2653 5.0457-5.0587v-31.151c0-21.22-13.499-39.962-33.591-46.636zm-53.058-80.39h41.94v25.53c-3.594 1.5075-7.4833 2.3083-11.407 2.3083-9.2094 0-17.729-4.2028-23.372-11.53-0.95567-1.2404-2.43-1.9673-3.9937-1.9673-1.5631 0-3.038 0.72694-3.9937 1.9668-4.5956 5.9672-11.098 9.8604-18.326 11.101v-8.2077c0-10.587 8.5913-19.201 19.152-19.201zm-19.152 39.934v-2.3062c8.4253-1.0669 16.201-4.783 22.32-10.674 7.3238 7.0513 17.019 11.002 27.365 11.002 3.8711 0 7.7204-0.57721 11.407-1.6856v3.664c0 16.887-13.703 30.625-30.547 30.625s-30.546-13.738-30.546-30.625zm44.07 38.414v7.2663c0 7.4752-6.066 13.557-13.522 13.557-7.4565 0-13.522-6.0815-13.522-13.557v-7.2658c4.2328 1.5019 8.782 2.328 13.521 2.328 4.7404 0 9.2901-0.82609 13.524-2.3285zm37.944 74.771v-27.769c0-2.7934-2.2595-5.0587-5.0457-5.0587s-5.0457 2.2653-5.0457 5.0587v27.769h-82.75v-27.769c0-2.7934-2.2595-5.0587-5.0457-5.0587s-5.0457 2.2653-5.0457 5.0587v27.769h-13.697v-26.092c0-16.851 10.719-31.733 26.673-37.034l14.877-4.9428v0.56252c0 13.054 10.593 23.675 23.614 23.675s23.614-10.62 23.614-23.675v-0.56252l14.875 4.9423c15.954 5.3005 26.673 20.183 26.673 37.034v26.093z",
    fill: "#5374a5",
    strokeWidth: 1.3438
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrainingImg);
export default __webpack_public_path__ + "static/media/Training_img.576d08822e2fc59eb7d80e69cb000803.svg";
export { ForwardRef as ReactComponent };